import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const STATS = [
  { value: 780, suffix: "+", label: "Products live online" },
  { value: 11000, format: "k", suffix: "+", label: "Sqft showroom floor" },
  { value: 10000, format: "k", suffix: "+", label: "Happy customers" },
  { prefix: "$", value: 299, suffix: "+", label: "Free local delivery" },
];

function fmt(n, format) {
  if (format === "k" && n >= 1000) return `${Math.round(n / 100) / 10}K`;
  return Math.round(n).toLocaleString();
}

function CountUp({ value, prefix = "", suffix = "", format, start }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf;
    const t0 = performance.now();
    const dur = 1500;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, value]);
  return (
    <span>
      {prefix}
      {fmt(n, format)}
      {suffix}
    </span>
  );
}

export default function StatsCounter() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} className="bg-[#0A1E5E] border-y-2 border-[#F0B90B]/40" data-testid="stats-counter-strip">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-10 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8">
        {STATS.map((s, i) => (
          <div key={i} className="text-center lg:text-left lg:border-l lg:border-[#F0B90B]/20 lg:pl-6 first:border-l-0 first:pl-0">
            <div className="font-display font-black text-3xl sm:text-4xl gold-shimmer-text" data-testid={`stat-value-${i}`}>
              <CountUp {...s} start={inView} />
            </div>
            <div className="ipv-eyebrow mt-2 text-slate-200/60">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
